import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents }: ComposedTheme) => ({
  inline: {},
  root: {
    '&$inline': {
      display: 'flex',
    },
    display: 'block',
    marginBottom: formComponents.container.marginBottom,
  },
  wrap: {},
  inlineSelect: {
    flex: 1,
  },
});

export default createUseStyles(styles);
